 $(document).ready(function () {
        var owl = $('.mainslider .owl-carousel');
        owl.owlCarousel({
            loop: true,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 3500,
            autoplayHoverPause: false,
            animateOut: 'fadeOut',
            responsive: {
                0: {
                    items: 1,
                    margin: 0
                }
            }
        });
        var owl2 = $('.sliders .owl-carousel');
        owl2.owlCarousel({
            loop: !0,
            nav: !0,
            dots:0,
            responsive: {
                0: {
                    items: 2,
                    margin: 10
                },
                500: {
                    items: 2,
                    margin: 10
                },
                768: {
                    items: 3,
                    margin: 10
                },
                1023: {
                    items: 4,
                    margin: 20
                }
            }
        });
    });
    
    $(function () {
        $('.foot').addClass('home-popup')
    });
    $(document).ready(function () {
        $(".popup-close").click(function () {
            $(".home-popup").hide()
        })
    })